var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mt-2 mb-2",staticStyle:{"text-align":"center"}},[_c('img',{staticStyle:{"width":"50px"},attrs:{"src":"/loading-image.gif"}})])])
}]

export { render, staticRenderFns }